export default __webpack_public_path__ + "static/harmonious-carousel-panel3-1a07e36a1045d4197a649592e844ba5bbcc2a1a0428ddb0ecbf7996d9abe8ba2.png";